/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ThemePreviewRouteImport } from "./routes/theme-preview"
import { Route as TeamsRouteImport } from "./routes/teams"
import { Route as StatsRouteImport } from "./routes/stats"
import { Route as SettingsRouteImport } from "./routes/settings"
import { Route as PlayersRouteImport } from "./routes/players"
import { Route as GamesRouteImport } from "./routes/games"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as TeamsIndexRouteImport } from "./routes/teams.index"
import { Route as PlayersIndexRouteImport } from "./routes/players.index"
import { Route as GamesIndexRouteImport } from "./routes/games.index"
import { Route as TeamsTeamIdRouteImport } from "./routes/teams.$teamId"
import { Route as SignUpSplatRouteImport } from "./routes/sign-up.$"
import { Route as SignInSplatRouteImport } from "./routes/sign-in.$"
import { Route as SandboxErrorRouteImport } from "./routes/sandbox.error"
import { Route as PlayersPlayerIdRouteImport } from "./routes/players.$playerId"
import { Route as GamesGameIdRouteImport } from "./routes/games.$gameId"

const ThemePreviewRoute = ThemePreviewRouteImport.update({
  id: "/theme-preview",
  path: "/theme-preview",
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsRoute = TeamsRouteImport.update({
  id: "/teams",
  path: "/teams",
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: "/stats",
  path: "/stats",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersRoute = PlayersRouteImport.update({
  id: "/players",
  path: "/players",
  getParentRoute: () => rootRouteImport,
} as any)
const GamesRoute = GamesRouteImport.update({
  id: "/games",
  path: "/games",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsIndexRoute = TeamsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => TeamsRoute,
} as any)
const PlayersIndexRoute = PlayersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PlayersRoute,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => GamesRoute,
} as any)
const TeamsTeamIdRoute = TeamsTeamIdRouteImport.update({
  id: "/$teamId",
  path: "/$teamId",
  getParentRoute: () => TeamsRoute,
} as any)
const SignUpSplatRoute = SignUpSplatRouteImport.update({
  id: "/sign-up/$",
  path: "/sign-up/$",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: "/sign-in/$",
  path: "/sign-in/$",
  getParentRoute: () => rootRouteImport,
} as any)
const SandboxErrorRoute = SandboxErrorRouteImport.update({
  id: "/sandbox/error",
  path: "/sandbox/error",
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersPlayerIdRoute = PlayersPlayerIdRouteImport.update({
  id: "/$playerId",
  path: "/$playerId",
  getParentRoute: () => PlayersRoute,
} as any)
const GamesGameIdRoute = GamesGameIdRouteImport.update({
  id: "/$gameId",
  path: "/$gameId",
  getParentRoute: () => GamesRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/games": typeof GamesRouteWithChildren
  "/players": typeof PlayersRouteWithChildren
  "/settings": typeof SettingsRoute
  "/stats": typeof StatsRoute
  "/teams": typeof TeamsRouteWithChildren
  "/theme-preview": typeof ThemePreviewRoute
  "/games/$gameId": typeof GamesGameIdRoute
  "/players/$playerId": typeof PlayersPlayerIdRoute
  "/sandbox/error": typeof SandboxErrorRoute
  "/sign-in/$": typeof SignInSplatRoute
  "/sign-up/$": typeof SignUpSplatRoute
  "/teams/$teamId": typeof TeamsTeamIdRoute
  "/games/": typeof GamesIndexRoute
  "/players/": typeof PlayersIndexRoute
  "/teams/": typeof TeamsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/settings": typeof SettingsRoute
  "/stats": typeof StatsRoute
  "/theme-preview": typeof ThemePreviewRoute
  "/games/$gameId": typeof GamesGameIdRoute
  "/players/$playerId": typeof PlayersPlayerIdRoute
  "/sandbox/error": typeof SandboxErrorRoute
  "/sign-in/$": typeof SignInSplatRoute
  "/sign-up/$": typeof SignUpSplatRoute
  "/teams/$teamId": typeof TeamsTeamIdRoute
  "/games": typeof GamesIndexRoute
  "/players": typeof PlayersIndexRoute
  "/teams": typeof TeamsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/games": typeof GamesRouteWithChildren
  "/players": typeof PlayersRouteWithChildren
  "/settings": typeof SettingsRoute
  "/stats": typeof StatsRoute
  "/teams": typeof TeamsRouteWithChildren
  "/theme-preview": typeof ThemePreviewRoute
  "/games/$gameId": typeof GamesGameIdRoute
  "/players/$playerId": typeof PlayersPlayerIdRoute
  "/sandbox/error": typeof SandboxErrorRoute
  "/sign-in/$": typeof SignInSplatRoute
  "/sign-up/$": typeof SignUpSplatRoute
  "/teams/$teamId": typeof TeamsTeamIdRoute
  "/games/": typeof GamesIndexRoute
  "/players/": typeof PlayersIndexRoute
  "/teams/": typeof TeamsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/games"
    | "/players"
    | "/settings"
    | "/stats"
    | "/teams"
    | "/theme-preview"
    | "/games/$gameId"
    | "/players/$playerId"
    | "/sandbox/error"
    | "/sign-in/$"
    | "/sign-up/$"
    | "/teams/$teamId"
    | "/games/"
    | "/players/"
    | "/teams/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/settings"
    | "/stats"
    | "/theme-preview"
    | "/games/$gameId"
    | "/players/$playerId"
    | "/sandbox/error"
    | "/sign-in/$"
    | "/sign-up/$"
    | "/teams/$teamId"
    | "/games"
    | "/players"
    | "/teams"
  id:
    | "__root__"
    | "/"
    | "/games"
    | "/players"
    | "/settings"
    | "/stats"
    | "/teams"
    | "/theme-preview"
    | "/games/$gameId"
    | "/players/$playerId"
    | "/sandbox/error"
    | "/sign-in/$"
    | "/sign-up/$"
    | "/teams/$teamId"
    | "/games/"
    | "/players/"
    | "/teams/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GamesRoute: typeof GamesRouteWithChildren
  PlayersRoute: typeof PlayersRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  StatsRoute: typeof StatsRoute
  TeamsRoute: typeof TeamsRouteWithChildren
  ThemePreviewRoute: typeof ThemePreviewRoute
  SandboxErrorRoute: typeof SandboxErrorRoute
  SignInSplatRoute: typeof SignInSplatRoute
  SignUpSplatRoute: typeof SignUpSplatRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/theme-preview": {
      id: "/theme-preview"
      path: "/theme-preview"
      fullPath: "/theme-preview"
      preLoaderRoute: typeof ThemePreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/teams": {
      id: "/teams"
      path: "/teams"
      fullPath: "/teams"
      preLoaderRoute: typeof TeamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/stats": {
      id: "/stats"
      path: "/stats"
      fullPath: "/stats"
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/players": {
      id: "/players"
      path: "/players"
      fullPath: "/players"
      preLoaderRoute: typeof PlayersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/games": {
      id: "/games"
      path: "/games"
      fullPath: "/games"
      preLoaderRoute: typeof GamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/teams/": {
      id: "/teams/"
      path: "/"
      fullPath: "/teams/"
      preLoaderRoute: typeof TeamsIndexRouteImport
      parentRoute: typeof TeamsRoute
    }
    "/players/": {
      id: "/players/"
      path: "/"
      fullPath: "/players/"
      preLoaderRoute: typeof PlayersIndexRouteImport
      parentRoute: typeof PlayersRoute
    }
    "/games/": {
      id: "/games/"
      path: "/"
      fullPath: "/games/"
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof GamesRoute
    }
    "/teams/$teamId": {
      id: "/teams/$teamId"
      path: "/$teamId"
      fullPath: "/teams/$teamId"
      preLoaderRoute: typeof TeamsTeamIdRouteImport
      parentRoute: typeof TeamsRoute
    }
    "/sign-up/$": {
      id: "/sign-up/$"
      path: "/sign-up/$"
      fullPath: "/sign-up/$"
      preLoaderRoute: typeof SignUpSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in/$": {
      id: "/sign-in/$"
      path: "/sign-in/$"
      fullPath: "/sign-in/$"
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sandbox/error": {
      id: "/sandbox/error"
      path: "/sandbox/error"
      fullPath: "/sandbox/error"
      preLoaderRoute: typeof SandboxErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/players/$playerId": {
      id: "/players/$playerId"
      path: "/$playerId"
      fullPath: "/players/$playerId"
      preLoaderRoute: typeof PlayersPlayerIdRouteImport
      parentRoute: typeof PlayersRoute
    }
    "/games/$gameId": {
      id: "/games/$gameId"
      path: "/$gameId"
      fullPath: "/games/$gameId"
      preLoaderRoute: typeof GamesGameIdRouteImport
      parentRoute: typeof GamesRoute
    }
  }
}

interface GamesRouteChildren {
  GamesGameIdRoute: typeof GamesGameIdRoute
  GamesIndexRoute: typeof GamesIndexRoute
}

const GamesRouteChildren: GamesRouteChildren = {
  GamesGameIdRoute: GamesGameIdRoute,
  GamesIndexRoute: GamesIndexRoute,
}

const GamesRouteWithChildren = GamesRoute._addFileChildren(GamesRouteChildren)

interface PlayersRouteChildren {
  PlayersPlayerIdRoute: typeof PlayersPlayerIdRoute
  PlayersIndexRoute: typeof PlayersIndexRoute
}

const PlayersRouteChildren: PlayersRouteChildren = {
  PlayersPlayerIdRoute: PlayersPlayerIdRoute,
  PlayersIndexRoute: PlayersIndexRoute,
}

const PlayersRouteWithChildren =
  PlayersRoute._addFileChildren(PlayersRouteChildren)

interface TeamsRouteChildren {
  TeamsTeamIdRoute: typeof TeamsTeamIdRoute
  TeamsIndexRoute: typeof TeamsIndexRoute
}

const TeamsRouteChildren: TeamsRouteChildren = {
  TeamsTeamIdRoute: TeamsTeamIdRoute,
  TeamsIndexRoute: TeamsIndexRoute,
}

const TeamsRouteWithChildren = TeamsRoute._addFileChildren(TeamsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GamesRoute: GamesRouteWithChildren,
  PlayersRoute: PlayersRouteWithChildren,
  SettingsRoute: SettingsRoute,
  StatsRoute: StatsRoute,
  TeamsRoute: TeamsRouteWithChildren,
  ThemePreviewRoute: ThemePreviewRoute,
  SandboxErrorRoute: SandboxErrorRoute,
  SignInSplatRoute: SignInSplatRoute,
  SignUpSplatRoute: SignUpSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
